var _rect, _rect2, _mask, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermlifeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.7736,
    height: 67,
    rx: 17.5738,
    fill: "#F7F6F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5,
    y: 32.5,
    width: 17,
    height: 2,
    fill: "url(#paint0_diamond_7153_14263)",
    fillOpacity: 0.44,
    stroke: "#187C85"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_7153_14263",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3867 31.7443L28.0002 31.7441L28.0002 32.2561L44.3867 32.2563V31.7443ZM44.3867 34.7444L28 34.7444V35.2563L44.3867 35.2563V34.7444Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3867 31.7443H45.3867V30.7443L44.3867 30.7443L44.3867 31.7443ZM28.0002 31.7441L28.0002 30.7441L27.0002 30.7441L27.0002 31.7441L28.0002 31.7441ZM28.0002 32.2561L27.0002 32.2561L27.0002 33.2561L28.0002 33.2561L28.0002 32.2561ZM44.3867 32.2563L44.3866 33.2563L45.3867 33.2563V32.2563H44.3867ZM44.3867 34.7444H45.3867V33.7444H44.3867V34.7444ZM28 34.7444L28 33.7444H27V34.7444H28ZM28 35.2563H27V36.2563H28L28 35.2563ZM44.3867 35.2563V36.2563H45.3867V35.2563H44.3867ZM44.3867 30.7443L28.0002 30.7441L28.0002 32.7441L44.3866 32.7443L44.3867 30.7443ZM27.0002 31.7441L27.0002 32.2561L29.0002 32.2561L29.0002 31.7442L27.0002 31.7441ZM28.0002 33.2561L44.3866 33.2563L44.3867 31.2563L28.0002 31.2561L28.0002 33.2561ZM45.3867 32.2563V31.7443H43.3867V32.2563H45.3867ZM44.3867 33.7444L28 33.7444L28 35.7444L44.3867 35.7444V33.7444ZM27 34.7444V35.2563H29V34.7444H27ZM28 36.2563L44.3867 36.2563V34.2563L28 34.2563L28 36.2563ZM45.3867 35.2563V34.7444H43.3867V35.2563H45.3867Z",
    fill: "#187C85",
    mask: "url(#path-3-inside-1_7153_14263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 23.5006L26.5368 23.5006C26.9919 23.5261 27.5 24.0188 27.5 24.8291L27.5 42.1704C27.5 43.0019 26.9638 43.5 26.5 43.5C26.0361 43.5 25.4999 43.0019 25.4999 42.1704L25.4999 24.8302C25.4999 23.9978 26.036 23.5006 26.5 23.5006Z",
    fill: "url(#paint1_linear_7153_14263)",
    fillOpacity: 0.44,
    stroke: "#187C85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 23.5006L45.5368 23.5006C45.9919 23.5261 46.5 24.0188 46.5 24.8291L46.5 42.1704C46.5 43.0019 45.9638 43.5 45.5 43.5C45.0361 43.5 44.4999 43.0019 44.4999 42.1704L44.4999 24.8302C44.4999 23.9978 45.036 23.5006 45.5 23.5006Z",
    fill: "url(#paint2_linear_7153_14263)",
    fillOpacity: 0.44,
    stroke: "#187C85"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_7153_14263",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.375 32) rotate(177.686) scale(49.5404 22.8815)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14263",
    x1: 33.16,
    y1: 18.22,
    x2: 25.2192,
    y2: 41.2283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7153_14263",
    x1: 52.16,
    y1: 18.22,
    x2: 44.2192,
    y2: 41.2283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermlifeIcon);
export default __webpack_public_path__ + "static/media/termlife-icon.4125ac18f33e5d41cb2863aba33261a0.svg";
export { ForwardRef as ReactComponent };